import { render } from "./CartFloat.vue?vue&type=template&id=45d51944"
import script from "./CartFloat.vue?vue&type=script&lang=js"
export * from "./CartFloat.vue?vue&type=script&lang=js"
script.render = render

export default script